import { actionTypes, CreateRoleInput, RolePaylodProps, RoleProps, UpdateRoleInput } from "./actionType";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { fetchRoles } from "../graphql/query";
import { CREATE_ROLE, Delete_ROLE, UPDATE_ROLE } from "../graphql/mutation";
import { showSnackbar } from "utils/snack_bar/store/action";

export const fetchRolesRequest = () => ({
  type: actionTypes.FETCH_ROLES_REQUEST,
});

export const fetchRolesSuccess = (payload: RolePaylodProps[]) => ({
  type: actionTypes.FETCH_ROLES_SUCCESS,
  payload,
});

export const fetchRolesFail = (payload: string) => ({
  type: actionTypes.FETCH_ROLES_FAIL,
  payload,
});

export const fetchAllRoles = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchRolesRequest());
      const response = await executeQuery(fetchRoles);
      const jsonData = response.data?.fetchRoles;
      if (jsonData?.error === null) {
        dispatch(fetchRolesSuccess(jsonData?.data.roles));
      } else {
        dispatch(fetchRolesFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchRolesFail("Failed to fetch fetchRole(s)"));
    }
  };
};

//create role
export const createRoleRequest = () => ({
  type: actionTypes.CREATE_ROLE_REQUEST,
});

export const createRoleSuccess = (payload: RoleProps) => ({
  type: actionTypes.CREATE_ROLE_SUCCESS,
  payload,
});

export const createRoleFail = (payload: string) => ({
  type: actionTypes.CREATE_ROLE_FAIL,
  payload,
});

export const createRole = (input: CreateRoleInput) => {
  return async (dispatch: any) => {
    try {
      dispatch(createRoleRequest());
      const input_data = {
        input: input
      };
      const response = await executeMutation(CREATE_ROLE, input_data);
      const jsonData = response.data?.createRole;
      if (jsonData?.error === null) {
        dispatch(createRoleSuccess(jsonData?.data.role));
        dispatch(showSnackbar('Success! Role created.'));
      } else {
        dispatch(createRoleFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error:${jsonData?.error.message? jsonData.error.message : "Fail to create."}`));
      }
    } catch (error: any) {
      dispatch(createRoleFail("Failed to create role"));
    }
  };
};
//update role
export const updateRoleRequest = () => ({
  type: actionTypes.UPDATE_ROLE_REQUEST,
});

export const updateRoleSuccess = (payload: RoleProps) => ({
  type: actionTypes.UPDATE_ROLE_SUCCESS,
  payload,
});

export const updateRoleFail = (payload: string) => ({
  type: actionTypes.UPDATE_ROLE_FAIL,
  payload,
});

export const updateRole = (input:UpdateRoleInput) => {
  return async (dispatch: any) => {
    try {
      dispatch(updateRoleRequest());
      const input_data = {
       input: input
      };
      const response = await executeMutation(UPDATE_ROLE, input_data);
      const jsonData = response.data?.updateRole;
      if (jsonData?.error === null) {
        dispatch(updateRoleSuccess(jsonData?.data.role));
        dispatch(showSnackbar('Success! Role updated.'));
      } else {
        dispatch(updateRoleFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error:${jsonData?.error.message? jsonData.error.message : "Fail to create."}`));
      }
    } catch (error: any) {
      dispatch(updateRoleFail("Failed to update role)"));
    }
  };
};

//delete role
export const deleteRoleRequest = () => ({
    type: actionTypes.DELETE_ROLE_REQUEST,
});
export const deleteRoleSuccess = (payload: string) => ({
    type: actionTypes.DELETE_ROLE_SUCCESS,
    payload
});
export const deleteRoleFail = (payload: string) => ({
    type: actionTypes.DELETE_ROLE_FAIL,
    payload
});

export const deleteRole = (id:string) => {
    return async (dispatch: any) => {
        try {
          const input = {
                id:id,
            }
            const response = await executeMutation(Delete_ROLE,input);
            const jsonData = response.data?.deleteRole;
            if (jsonData?.error === null) {
                dispatch(deleteRoleSuccess(id));
                dispatch(showSnackbar('Success! Role deleted.'));
            } else {
                dispatch(deleteRoleFail(jsonData?.error.message));
                dispatch(showSnackbar(`Error: ${jsonData?.error.message}`));
            }
        } catch (error: any) {
            dispatch(deleteRoleFail('Something went wrong, Try again later'));
        }
    };
};
